import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["onSearch", "searchIcon", "isLoading", "loadingIcon"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../TextInput';
import { SearchIcon, LoadingIcon as DefaultLoading } from './styles';
var SearchInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SearchInput, _React$PureComponent);
  var _super = _createSuper(SearchInput);
  function SearchInput(props) {
    var _this;
    _classCallCheck(this, SearchInput);
    _this = _super.call(this, props);
    _this.renderIcon = _this.renderIcon.bind(_assertThisInitialized(_this));
    _this.onSearchHandler = _this.onSearchHandler.bind(_assertThisInitialized(_this));
    _this.onKeyPressHandler = _this.onKeyPressHandler.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(SearchInput, [{
    key: "onSearchHandler",
    value: function onSearchHandler(event) {
      event.preventDefault();
      event.persist();
      var _this$props = this.props,
        onSearch = _this$props.onSearch,
        value = _this$props.value;
      if (onSearch) {
        var ev = _extends({}, event);
        ev.target.value = value;
        onSearch(ev);
      }
    }
  }, {
    key: "onKeyPressHandler",
    value: function onKeyPressHandler(event) {
      if (event.key === 'Enter') {
        this.onSearchHandler(event);
      }
      var onKeyPress = this.props.onKeyPress;
      if (onKeyPress) onKeyPress(event);
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(iconProps) {
      var _this$props2 = this.props,
        Search = _this$props2.searchIcon,
        Loading = _this$props2.loadingIcon,
        onSearch = _this$props2.onSearch,
        isLoading = _this$props2.isLoading;
      if (isLoading) {
        return /*#__PURE__*/React.createElement(Loading, _extends({
          size: 16,
          thickness: 5
        }, iconProps));
      }
      return /*#__PURE__*/React.createElement(Search, _extends({
        role: "button",
        isClickable: Boolean(onSearch)
      }, iconProps, {
        onClick: this.onSearchHandler
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        onSearch = _this$props3.onSearch,
        searchIcon = _this$props3.searchIcon,
        isLoading = _this$props3.isLoading,
        loadingIcon = _this$props3.loadingIcon,
        props = _objectWithoutProperties(_this$props3, _excluded);
      return /*#__PURE__*/React.createElement(TextInput, _extends({
        onKeyPress: this.onKeyPressHandler,
        icon: this.renderIcon,
        disabled: isLoading
      }, props));
    }
  }]);
  return SearchInput;
}(React.PureComponent);
SearchInput.defaultProps = {
  isLoading: false,
  onSearch: undefined,
  searchIcon: SearchIcon,
  loadingIcon: DefaultLoading
};
process.env.NODE_ENV !== "production" ? SearchInput.propTypes = {
  isLoading: PropTypes.bool,
  onSearch: PropTypes.func,
  searchIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.node]),
  loadingIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.node])
} : void 0;
export default SearchInput;